import script from "./EditTaskModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditTaskModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditTaskModal.vue?vue&type=style&index=0&id=591622db&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591622db"]])

export default __exports__